var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gg:menu-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.33398 6.99433C2.33398 6.35266 2.85432 5.8335 3.49482 5.8335H12.8398C13.1477 5.8335 13.443 5.9558 13.6607 6.1735C13.8784 6.39119 14.0007 6.68646 14.0007 6.99433C14.0007 7.3022 13.8784 7.59746 13.6607 7.81516C13.443 8.03286 13.1477 8.15516 12.8398 8.15516H3.49482C3.18695 8.15516 2.89168 8.03286 2.67398 7.81516C2.45629 7.59746 2.33398 7.3022 2.33398 6.99433ZM2.33398 14.0002C2.33398 13.3585 2.85432 12.8393 3.49482 12.8393H24.5065C24.8144 12.8393 25.1096 12.9616 25.3273 13.1793C25.545 13.397 25.6673 13.6923 25.6673 14.0002C25.6673 14.308 25.545 14.6033 25.3273 14.821C25.1096 15.0387 24.8144 15.161 24.5065 15.161H3.49482C3.18695 15.161 2.89168 15.0387 2.67398 14.821C2.45629 14.6033 2.33398 14.308 2.33398 14.0002ZM3.49482 19.8452C3.18695 19.8452 2.89168 19.9675 2.67398 20.1852C2.45629 20.4029 2.33398 20.6981 2.33398 21.006C2.33398 21.3139 2.45629 21.6091 2.67398 21.8268C2.89168 22.0445 3.18695 22.1668 3.49482 22.1668H17.5065C17.8144 22.1668 18.1096 22.0445 18.3273 21.8268C18.545 21.6091 18.6673 21.3139 18.6673 21.006C18.6673 20.6981 18.545 20.4029 18.3273 20.1852C18.1096 19.9675 17.8144 19.8452 17.5065 19.8452H3.49482Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLeft);
export default __webpack_public_path__ + "static/media/menu-left.42442969b760b0080e36a2c4cd90d522.svg";
export { ForwardRef as ReactComponent };